import { Routes, Route, NavLink } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { DashboardPage } from './DashboardPage';
import { AccountsPage } from './AccountsPage';
import { ComposerPage } from './ComposerPage';
import { ScheduledPage } from './ScheduledPage';
import { DraftsPage } from './DraftsPage';
import { PublishedPage } from './PublishedPage';

function SocialMediaNav() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? 'bg-primary/10 text-primary'
        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
    }`;

  return (
    <nav className="flex items-center gap-1 px-4 py-2 border-b bg-card">
      <NavLink to="/a/arche_social_media/" end className={linkClass}>
        Dashboard
      </NavLink>
      <NavLink to="/a/arche_social_media/compose" className={linkClass}>
        Compose
      </NavLink>
      <NavLink to="/a/arche_social_media/scheduled" className={linkClass}>
        Scheduled
      </NavLink>
      <NavLink to="/a/arche_social_media/drafts" className={linkClass}>
        Drafts
      </NavLink>
      <NavLink to="/a/arche_social_media/published" className={linkClass}>
        Published
      </NavLink>
      <NavLink to="/a/arche_social_media/accounts" className={linkClass}>
        Accounts
      </NavLink>
    </nav>
  );
}

/**
 * Arche wrapper for Social Media — provides ArcheLayout with sidebar
 * and handles sub-routing for all social media pages.
 */
export function SocialMediaArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <SocialMediaNav />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/compose" element={<ComposerPage />} />
            <Route path="/compose/:postId" element={<ComposerPage />} />
            <Route path="/scheduled" element={<ScheduledPage />} />
            <Route path="/drafts" element={<DraftsPage />} />
            <Route path="/published" element={<PublishedPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
